import React, { useState, useEffect, useRef } from 'react';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import '../ConnectionStatus/ConnectionStatus.css';

function SendSmsModal({ isOpen, onClose, onSendSms, simCards = [] }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [selectedSimIndex, setSelectedSimIndex] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setPhoneNumber('');
      setMessage('');
      setSelectedSimIndex(0);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (!phoneNumber.trim() || !message.trim()) {
      toastr.warning(' ', 'Номер телефона и текст сообщения не могут быть пустыми.');
      return;
    }
    
    onSendSms(phoneNumber, message, selectedSimIndex);
    onClose();
  };

  const renderSimSelection = () => {
    if (!simCards || simCards.length === 0) {
      return <p style={{ color: '#e74c3c', marginBottom: '15px' }}>Нет доступных SIM-карт для отправки.</p>;
    }

    const selectedSim = simCards.find(s => (s.simSlotIndex !== undefined ? s.simSlotIndex : simCards.indexOf(s)) === selectedSimIndex);
    const isSelectedExtracted = selectedSim && selectedSim.carrierName === 'Извлечена/удалена';

    return (
      <div style={{ marginBottom: '15px', border: '1px solid #444', borderRadius: '4px', padding: '10px' }}>
        <h5 style={{ marginTop: 0, marginBottom: '10px', color: '#ccc' }}>Отправить с SIM:</h5>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {simCards.map((sim, index) => {
            const slotIndex = sim.simSlotIndex !== undefined ? sim.simSlotIndex : index;
            const isExtracted = sim.carrierName === 'Извлечена/удалена';
            
            return (
              <label key={sim.iccId || index} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                <input
                  type="radio"
                  name="simCard"
                  value={slotIndex}
                  checked={selectedSimIndex === slotIndex}
                  onChange={() => setSelectedSimIndex(slotIndex)}
                  style={{ marginRight: '5px' }}
                />
                Слот {slotIndex + 1} - {sim.number || 'Нет номера'} {isExtracted ? '(❌ Извлечена/удалена)' : `(${sim.carrierName || 'Неизвестно'})`}
              </label>
            );
          })}
        </div>
        {isSelectedExtracted && (
          <div style={{ color: '#e74c3c', fontSize: '12px', marginTop: '10px' }}>
            ⚠️ Эта SIM-карта была извлечена или возврат пустоты от устройства. Запрос может завершиться ошибкой.
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: '450px' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h4>Отправить СМС</h4>
        </div>
        <div className="modal-body">
          {renderSimSelection()}
          <input
            type="text"
            placeholder="Номер телефона"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            style={{ width: '100%', padding: '10px', marginBottom: '10px', boxSizing: 'border-box' }}
          />
          <textarea
            placeholder="Текст сообщения"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ width: '100%', padding: '10px', marginBottom: '15px', boxSizing: 'border-box', minHeight: '100px', resize: 'vertical' }}
          />
        </div>
        <div className="modal-actions" style={{ justifyContent: 'flex-end' }}>
          <button onClick={onClose}>Отмена</button>
          <button onClick={handleSubmit}>Отправить</button>
        </div>
      </div>
    </div>
  );
}

export default SendSmsModal;